var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{},[_c('div',{staticClass:"d-flex filter-wrap"},[_c('filter-sidebar',{on:{"input":_vm.onFilterChange}}),_c('report-result-tabs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }